import { cx } from '@emotion/css';
import React from 'react';
import { modalOverlay, modalOverlayOpen } from './overlay-css';
/**
 * Modal background overlay.
 */
export var ModalOverlay = function (_a) {
    var _b;
    var onClick = _a.onClick, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: cx((_b = {},
            _b[modalOverlay] = true,
            _b[modalOverlayOpen] = isOpen,
            _b)), onClick: onClick }));
};
